import { useEffect, useState } from "react";
import { getQuote } from "./stockApi.js";

// Like useAsync(() => getQuote(ticker)), but re-checks every `ms` milliseconds
// (while the browser tab is visible) and keeps showing the last price meanwhile.
export default function useLiveQuote(ticker, ms = 30000) {
  const [state, setState] = useState({ data: null, loading: true, error: null });
  useEffect(() => {
    let live = true;
    setState({ data: null, loading: true, error: null });
    const load = () =>
      getQuote(ticker)
        .then((data) => live && setState({ data, loading: false, error: null }))
        .catch((error) => live && setState((s) => ({ data: s.data, loading: false, error: s.data ? null : error })));
    load();
    const id = setInterval(() => { if (!document.hidden) load(); }, ms);
    return () => { live = false; clearInterval(id); };
  }, [ticker, ms]);
  return state;
}